<div class="container mt-5 pt-5" style="margin-bottom: 15rem !important">
  <div class="row">
    <div class="col-sm-2"></div>

    <div class="col-sm-8">
      <div style="text-align: justify">
        <h1 class="text-center" style="color: #c41e3a; margin-bottom: 2rem;">
          TÉRMINOS Y CONDICIONES DE ARCHIVO HISTÓRICO DIGITAL DE EDITORA PERÚ
        </h1>

              <div class="section">
                <h5 class="subsection-title">I. CONDICIONES GENERALES</h5>
                <p class="text-justify">
                  El presente documento establece los términos y condiciones que
                  regulan el uso del sitio web
                  <a
                    href="https://archivohistorico.elperuano.pe"
                    target="_blank"
                  >
                    https://archivohistorico.elperuano.pe
                  </a>
                  y sus contenidos, en adelante "el Sitio Web" o "Archivo
                  Histórico". La plataforma es administrada por la Empresa Peruana
                  de Servicios Editoriales SA - Editora Perú (en adelante,
                  "Editora Perú"), identificada con RUC Nº 20100072751, con
                  domicilio en la Av. Alfonso Ugarte N° 873, Cercado de Lima.
                </p>
                <p class="text-justify">
                  Archivo Histórico permite al Usuario adquirir licencias de uso de
                  fotografías y portadas históricas del Diario Oficial El
                  Peruano mediante un procedimiento completamente electrónico.
                </p>
                <p class="text-justify">
                  El acceso y uso del Sitio Web implica la aceptación plena y
                  sin reservas de los presentes Términos y Condiciones.
                </p>
              </div>

              <div class="section">
                <h5 class="subsection-title">
                  II. SERVICIOS OFRECIDOS POR ARCHIVO HISTÓRICO
                </h5>
                <p class="text-justify">
                  El Archivo Histórico tiene como objetivo la comercialización y/o
                  adquisición de licencias de uso de fotografías y portadas
                  históricas del Diario Oficial El Peruano custodiadas por el
                  Centro de Documentación, así como cualquier otro tipo de obra
                  o producto cuyos derechos sean propiedad de Editora Perú.
                  Mediante un proceso electrónico se facilita su acceso y
                  adquisición.
                </p>
              </div>

              <div class="section">
                <h5 class="subsection-title">
                  III. REGISTRO Y RESPONSABILIDAD POR CONTRASEÑAS
                </h5>
                <p class="text-justify">
                  El usuario del sitio web puede explorar el catálogo sin
                  requerir un registro de cuenta. No obstante, la inscripción es
                  obligatoria para llevar a cabo la compra de licencias de uso.
                  Para ello, el usuario deberá completar un formulario de
                  registro proporcionando los siguientes datos:
                </p>
                <ul>
                  <li>Nombre completo</li>
                  <li>
                    Documento de identidad, carné de extranjería o pasaporte
                  </li>
                  <li>Correo electrónico</li>
                  <li>Dirección</li>
                  <li>Teléfono</li>
                  <li>(En caso de personas jurídicas): RUC y razón social</li>
                </ul>
                <p class="text-justify">
                  Asimismo, deberá aceptar los presentes Términos y Condiciones,
                  así como la Política de Privacidad disponible en:
                  <a
                    href="https://www.editoraperu.com.pe/PrivacidadEP/Politica_Proteccion_Datos_Personales.pdf"
                    target="_blank"
                  >
                    Política de Privacidad
                  </a>
                </p>
                <p class="text-justify">
                  El usuario se compromete a mantener actualizada su información
                  y garantiza la veracidad y exactitud de los datos ingresados,
                  los cuales se consideran una declaración jurada. Editora
                  Perú no se hace responsable por errores derivados de datos
                  incorrectos o desactualizados.
                </p>
                <p class="text-justify">
                  Cada usuario contará con una contraseña de uso personal e
                  intransferible. Editora Perú no se responsabiliza por accesos
                  no autorizados si el usuario comparte su contraseña.
                </p>
              </div>

              <div class="section">
                <h5 class="subsection-title">
                  IV. ACCESO Y ACEPTACIÓN DEL USUARIO
                </h5>
                <p class="text-justify">
                  Los presentes Términos y Condiciones regulan el acceso y uso
                  de los servicios ofrecidos por Editora Perú a través de Archivo
                  Histórico. La calidad de "Usuario" se adquiere con la mera
                  navegación o uso del Sitio Web.
                </p>
                <p class="text-justify">
                  Para la compra de licencias de uso, es necesario que el
                  Usuario cree una cuenta.
                </p>
              </div>

              <div class="section">
                <h5 class="subsection-title">
                  V. CONTRATACIÓN ELECTRÓNICA Y VALIDEZ DEL CONSENTIMIENTO
                </h5>
                <p class="text-justify">
                  El Usuario reconoce y acepta que la aceptación de los presentes
                  Términos y Condiciones y la adquisición de licencias de uso se
                  realizan por medios electrónicos, constituyendo manifestación
                  válida de voluntad conforme a la legislación peruana.
                </p>
                <p class="text-justify">
                  La confirmación de la operación enviada al correo electrónico
                  del Usuario constituye constancia de la contratación.
                </p>
                <p class="text-justify">
                  El consentimiento otorgado por el Usuario mediante medios
                  electrónicos será almacenado de manera trazable, verificable y
                  auditable, constituyendo plena prueba de la manifestación de
                  voluntad, conforme a la legislación peruana vigente.
                </p>
              </div>

              <div class="section">
                <h5 class="subsection-title">
                  VI. REQUISITOS PARA CONTRATAR Y ADQUIRIR LA LICENCIA DE USO DE
                  NUESTRAS OBRAS Y PRODUCTOS
                </h5>
                <p class="text-justify">
                  Los productos de Archivo Histórico están disponibles únicamente
                  para personas mayores de edad con capacidad legal. No podrán
                  registrarse personas menores de edad ni usuarios cuya cuenta
                  haya sido suspendida o cerrada. Cualquier acción realizada por
                  menores será considerada responsabilidad de sus padres o
                  tutores.
                </p>
                <p class="text-justify">
                  Si la compra se realiza en nombre de una entidad jurídica, el
                  representante declara:
                </p>
                <ol type="i">
                  <li>
                    Tener facultades suficientes para contratar en nombre de la
                    entidad o empresa.
                  </li>
                  <li>
                    Que la información proporcionada es veraz y actualizada.
                  </li>
                </ol>
              </div>

              <div class="section">
                <h5 class="subsection-title">
                  VII. TARIFARIO Y USOS DE LAS OBRAS Y PRODUCTOS OFRECIDOS EN
                  ARCHIVO HISTÓRICO
                </h5>

                <h6 class="subsection-subtitle">
                  <strong
                    >a. Tarifario para obras y productos en territorio
                    nacional</strong
                  >
                </h6>
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Detalle de las obras</th>
                      <th>Uso Particular</th>
                      <th>Uso Comercial</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Fotografías</td>
                      <td>S/ 50.00</td>
                      <td>S/ 120.00</td>
                    </tr>
                    <tr>
                      <td>Portada</td>
                      <td>S/ 15.00</td>
                      <td>S/ 50.00</td>
                    </tr>
                  </tbody>
                </table>
                <p class="text-justify"><em>Precios incluyen el IGV.</em></p>

                <h6 class="subsection-subtitle">
                  <strong
                    >b. Tarifario para obras y productos en territorio
                    extranjero</strong
                  >
                </h6>
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Detalle de las obras</th>
                      <th>Uso Comercial</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Fotografías</td>
                      <td>US$ 100.00</td>
                    </tr>
                    <tr>
                      <td>Portada</td>
                      <td>US$ 50.00</td>
                    </tr>
                  </tbody>
                </table>
                <p class="text-justify"><em>Precios incluyen el IGV.</em></p>
              </div>

              <div class="section">
                <h5 class="subsection-title">VIII. LICENCIAS DE USO</h5>
                <p class="text-justify">
                  Las licencias ofrecidas por el Archivo Histórico comprenden:
                </p>

                <h6 class="subsection-subtitle">
                  <strong>i. Para uso particular:</strong>
                </h6>
                <p class="text-justify">
                  Personas naturales o jurídicas pueden adquirir obras para
                  fines no comerciales, como decoración personal o
                  institucional. No está permitido el uso comercial de estas
                  obras.
                </p>

                <h6 class="subsection-subtitle">
                  <strong>ii. Para uso comercial:</strong>
                </h6>
                <p class="text-justify">
                  Aplicable para toda reproducción con fines publicitarios,
                  editoriales, audiovisuales o de exhibición pública. Incluye:
                </p>
                <ul>
                  <li>
                    Reproducción digital en sitios web, redes sociales, apps,
                    marketing por correo y plataformas como YouTube o Vimeo.
                  </li>
                  <li>Publicaciones impresas y embalaje de productos.</li>
                  <li>Publicidad física en vía pública.</li>
                  <li>
                    Producciones audiovisuales (películas, series, comerciales).
                  </li>
                </ul>

                <h6 class="subsection-subtitle">
                  <strong>iii. Créditos por el uso:</strong>
                </h6>
                <p class="text-justify">
                  Las licencias de las obras y productos comprados en el Archivo
                  Histórico para fines comerciales deben incluir los créditos
                  apropiados en reconocimiento de la titularidad de los derechos
                  patrimoniales de Editora Perú, y del respeto a los derechos
                  morales del autor. Esto es esencial para asegurar el respeto
                  de dichos derechos.
                </p>
                <p class="text-justify">
                  La licencia se otorga exclusivamente para la finalidad
                  declarada por el usuario. Está prohibida su reventa o cesión a
                  terceros, como también su reutilización por terceros ajenos a
                  la finalidad inicial. Editora Perú mantiene la titularidad de
                  los derechos patrimoniales.
                </p>
                <p class="text-justify">
                  Los presentes Términos y Condiciones, junto con la Política de
                  Privacidad y las condiciones particulares de la licencia
                  adquirida, constituyen el acuerdo íntegro entre el Usuario y
                  Editora Perú.
                </p>

                <h6 class="subsection-subtitle">
                  <strong>iv. Alcance territorial de la licencia:</strong>
                </h6>
                <p class="text-justify">
                  La licencia se otorga para el territorio expresamente declarado
                  por el Usuario al momento de la adquisición.
                </p>
              </div>

              <div class="section">
                <h5 class="subsection-title">IX. VIGENCIA</h5>
                <p class="text-justify">
                  La vigencia de las licencias de las fotografías y portadas
                  históricas dependerá del uso para el cual han sido obtenidas:
                </p>

                <h6 class="subsection-subtitle">
                  <strong>i. Para uso en territorio nacional:</strong>
                </h6>
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Uso</th>
                      <th>Vigencia</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Para uso particular</td>
                      <td>Indeterminado</td>
                    </tr>
                    <tr>
                      <td>Para uso comercial</td>
                      <td>Determinado según el uso solicitado</td>
                    </tr>
                  </tbody>
                </table>

                <h6 class="subsection-subtitle">
                  <strong>ii. Para uso en territorio extranjero:</strong>
                </h6>
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Uso</th>
                      <th>Vigencia</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Para uso comercial</td>
                      <td>Determinado según el uso solicitado</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div class="section">
                <h5 class="subsection-title">X. RESTRICCIONES</h5>
                <ol type="i">
                  <li class="text-justify">
                    Las fotografías y portadas históricas adquiridas bajo una
                    licencia de uso particular no podrán ser utilizadas con
                    fines de comercialización, venta, publicación ni en ningún
                    otro medio distinto al autorizado expresamente.
                  </li>

                  <li class="text-justify">
                    Las obras adquiridas mediante una licencia de uso comercial
                    deberán ser utilizadas con los créditos correspondientes a
                    Editora Perú, salvo que el Usuario haya obtenido
                    autorización expresa y previa para omitir dicha mención.
                  </li>

                  <li class="text-justify">
                    Está prohibido representar a las personas retratadas en las
                    fotografías o portadas históricas de forma ofensiva o
                    difamatoria. Se considera ofensivo, entre otros, el uso en
                    contextos relacionados con:
                    <ul>
                      <li>
                        Pornografía, servicios para adultos o acompañantes;
                      </li>
                      <li>Promoción de productos derivados del tabaco;</li>
                      <li>
                        Propaganda o actividades políticas de cualquier índole,
                        sin autorización expresa de Editora Perú;
                      </li>
                      <li>
                        Actividades ilícitas o contrarias a la moral y buenas
                        costumbres.
                      </li>
                    </ul>
                  </li>

                  <li class="text-justify">
                    Las obras no podrán ser modificadas, alteradas ni editadas
                    en su composición original. Está prohibida la extracción de
                    elementos, secciones o fragmentos para su uso en nuevas
                    composiciones.
                  </li>

                  <li class="text-justify">
                    Queda prohibida la reventa, redistribución, cesión, préstamo
                    o transferencia de las licencias de uso, salvo autorización
                    expresa y por escrito de Editora Perú.
                  </li>

                  <li class="text-justify">
                    En el caso de personas jurídicas, la licencia adquirida
                    quedará automáticamente revocada en caso de liquidación o
                    disolución de la entidad titular.
                  </li>

                  <li class="text-justify">
                    Está terminantemente prohibido utilizar las obras de manera
                    que infrinjan derechos de propiedad intelectual de terceros,
                    o que puedan dar lugar a acciones por competencia desleal o
                    publicidad engañosa.
                  </li>

                  <li class="text-justify">
                    Las obras licenciadas no podrán ser registradas como marca,
                    nombre comercial u otro signo distintivo.
                  </li>

                  <li class="text-justify">
                    Se prohíbe declarar, directa o indirectamente, que las obras
                    han sido creadas o producidas por un tercero distinto de
                    Editora Perú.
                  </li>

                  <li class="text-justify">
                    No está permitido sublicenciar las obras adquiridas, salvo
                    autorización expresa y previa por parte de Editora Perú.
                  </li>

                  <li class="text-justify">
                    No está permitida la manipulación, animación o modificación
                    de las imágenes a través de plataformas de inteligencia
                    artificial ni su utilización para entrenamiento de modelos de
                    inteligencia artificial, ni para la generación de obras
                    derivadas mediante sistemas automatizados.
                  </li>

                  <li class="text-justify">
                    Está completamente prohibido la reutilización por terceros,
                    ajenos al titular de la licencia de uso.
                  </li>
                </ol>
                <p class="text-justify">
                  En caso de infracción de cualquiera de las restricciones
                  previstas en esta cláusula o en el presente documento, Editora
                  Perú se reserva el derecho de tomar las acciones legales
                  correspondientes para salvar sus derechos. Asimismo,
                  podrá cancelar la licencia otorgada al Usuario infractor,
                  considerándose ésta automáticamente sin efecto desde el
                  momento en que se verifique el incumplimiento.
                </p>
              </div>

              <div class="section">
                <h5 class="subsection-title">
                  XI. PROCESO DE ADQUISICIÓN DE LAS LICENCIAS DE LAS FOTOGRAFÍAS
                  Y PORTADAS HISTÓRICAS OFRECIDAS EN EL ARCHIVO HISTÓRICO
                </h5>
                <p class="text-justify">
                  El Usuario selecciona la fotografía o portada histórica que
                  desea adquirir de acuerdo con la licencia de uso, luego deberá
                  agregarla al carrito de compra, registrarse con los datos
                  solicitados (en caso de que no haya creado y registrado una cuenta) y
                  finalmente proceder a realizar el pago.
                </p>
                <p class="text-justify">
                  Una vez realizado el pago, recibirá un email desde la cuenta:
                  <strong>
                    <a href="mailto:archivohistorico@editoraperu.com.pe"
                      >archivohistorico&#64;editoraperu.com.pe</a
                    >
                  </strong>
                  con los datos de la compra efectuada. Si la transacción es
                  exitosa y cumple con los requisitos necesarios, la obra o
                  producto adquirido podrá ser descargado. La descarga se
                  habilitará por una única vez, sin perjuicio del ejercicio de
                  los derechos otorgados por la licencia adquirida. Esto se
                  realizará dentro de los plazos establecidos a continuación:
                </p>

                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Fotos y Portadas Históricas</th>
                      <th>Plazo de entrega</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Obras y productos disponibles en el catálogo</td>
                      <td>Entrega inmediata</td>
                    </tr>
                    <tr>
                      <td>Obras y productos no disponibles en el catálogo</td>
                      <td>Previa coordinación</td>
                    </tr>
                  </tbody>
                </table>

                <p class="text-justify">
                  El comprobante de pago se enviará al correo electrónico
                  proporcionado por el Usuario en un plazo máximo de dos (2)
                  días hábiles después de que el Usuario haya recibido el
                  producto adquirido.
                </p>
                <p class="text-justify">
                  Dada la naturaleza digital de las obras y productos ofrecidos,
                  y considerando que el acceso y descarga del contenido se
                  realiza de forma inmediata, el Usuario reconoce y acepta que,
                  una vez efectuada la descarga del archivo digital, no procede
                  el derecho de devolución ni reembolso, salvo en los supuestos
                  expresamente previstos por la normativa de protección al
                  consumidor.
                </p>
                <p class="text-justify">
                  Editora Perú no garantiza que las descripciones, imágenes
                  referenciales o fichas técnicas estén exentas de errores
                  materiales. En caso se detecte un error sustancial que afecte
                  la naturaleza del producto adquirido, se coordinará con el
                  Usuario la sustitución del archivo o la anulación de la
                  operación, de corresponder.
                </p>
              </div>

              <div class="section">
                <h5 class="subsection-title">
                  XII. MEDIOS DE PAGOS QUE SE PODRÁN UTILIZAR EN ESTE SITIO
                </h5>
                <p class="text-justify">
                  Las fotografías y portadas históricas disponibles en Archivo
                  Histórico pueden pagarse mediante QR, tarjetas de crédito y/o
                  débito, monedero digital. Estos pagos a través de tarjetas se
                  gestionan a través de Niubiz, y se aceptan tarjetas de crédito
                  y débito VISA, Mastercard y American Express, emitidas por
                  entidades bancarias nacionales e internacionales. El uso de
                  tarjetas de crédito o débito está sujeto a los Términos y
                  Condiciones establecidos por el emisor de la tarjeta.
                </p>
              </div>

              <div class="section">
                <h5 class="subsection-title">
                  XIII. DESPACHO DE LAS FOTOGRAFÍAS Y PORTADAS HISTÓRICAS DEL
                  ARCHIVO HISTÓRICO
                </h5>
                <p class="text-justify">
                  Las Fotografías y Portadas Históricas en el Archivo Histórico serán
                  entregadas exclusivamente en formato digital. Además, las
                  obras y productos estarán disponibles en formato JPG y/o PDF
                  según las especificaciones contenidas en la ficha técnica de
                  cada obra o producto.
                </p>
              </div>

              <div class="section">
                <h5 class="subsection-title">XIV. COMPROBANTES DE PAGO</h5>
                <p class="text-justify">
                  Según el reglamento de Comprobantes de Pago aprobado por la
                  Resolución de Superintendencia N° 007-99 / SUNAT (RCP) y el
                  Texto Único Ordenado de la Ley del Impuesto General a las
                  Ventas e Impuesto Selectivo al Consumo, aprobado mediante
                  Decreto Supremo N° 055-99-EF y normas modificatorias (TUO del
                  IGV): "No existe ningún procedimiento vigente que permita el
                  canje de boletas de venta por facturas, más aún las notas de
                  crédito no se encuentran previstas para modificar al
                  adquirente o usuario que figura en el comprobante de pago
                  original".
                </p>
                <p class="text-justify">
                  Considerando lo mencionado anteriormente, es responsabilidad
                  del consumidor tomar una decisión informada sobre el documento
                  que solicitará como comprobante al realizar su compra, ya que,
                  de acuerdo con el párrafo citado, no se permitirán cambios
                  posteriores. Es importante destacar que el comprobante de pago
                  se envía al correo electrónico proporcionado por el Usuario
                  durante el registro.
                </p>
              </div>

              <div class="section">
                <h5 class="subsection-title">XV. USO DEL SITIO WEB</h5>
                <p class="text-justify">
                  Las licencias de las Fotografías y Portadas Históricas
                  disponibles a través del Archivo Histórico están destinadas
                  exclusivamente para personas que tengan la capacidad legal de
                  celebrar contratos según lo establecido por la legislación
                  aplicable. Al acceder al Sitio Web, el Usuario declara ser
                  mayor de 18 años y estar autorizado para asumir
                  responsabilidades vinculantes relacionadas con el uso del
                  Sitio Web. El Usuario se compromete a utilizar el Sitio Web en
                  conformidad con la legislación vigente, estos Términos y
                  Condiciones, así como los principios éticos, la moral, las
                  buenas costumbres y el orden público.
                </p>
                <p class="text-justify">
                  Con relación a esto, el Usuario se compromete a seguir las
                  siguientes pautas al utilizar el Sitio Web:
                </p>
                <ol type="i">
                  <li class="text-justify">
                    El Usuario no debe emplear el Sitio Web para propósitos
                    ilícitos o que vayan en contra de los términos establecidos
                    en los presentes Términos y Condiciones. Esto incluye evitar
                    acciones que puedan perjudicar los intereses o derechos de
                    terceros, así como cualquier acto que pueda dañar,
                    inhabilitar o afectar negativamente la plataforma o el
                    disfrute normal del Sitio Web por parte de otros Usuarios.
                  </li>

                  <li class="text-justify">
                    El Usuario se compromete a no destruir, alterar, inhabilitar
                    o dañar de ninguna manera los datos, programas, documentos
                    electrónicos y cualquier otro contenido presente en el Sitio
                    Web.
                  </li>

                  <li class="text-justify">
                    El Usuario no debe interferir en el acceso de otros Usuarios
                    mediante el uso excesivo de los recursos informáticos
                    utilizados por Editora Perú para prestar el servicio, ni
                    llevar a cabo acciones que puedan dañar, interrumpir o
                    generar errores en dichos sistemas o servicios.
                  </li>

                  <li class="text-justify">
                    El Usuario se compromete a no intentar acceder o probar la
                    vulnerabilidad de sistemas o redes relacionadas con el Sitio
                    Web, ni a violar las medidas de seguridad o autenticación de
                    este.
                  </li>

                  <li class="text-justify">
                    El Usuario debe hacer un uso apropiado de los contenidos
                    proporcionados en el Sitio Web y no debe utilizarlos para
                    llevar a cabo actividades ilegales.
                  </li>

                  <li class="text-justify">
                    En caso de que el Usuario viole las disposiciones establecidas
                    en esta sección, Editora Perú tomará una de las siguientes
                    medidas según la gravedad o frecuencia de la infracción: 1°
                    enviar una advertencia al Usuario; 2° suspenderá
                    temporalmente la cuenta del Usuario; y, 3° cancelará de manera
                    definitiva la cuenta del Usuario. Esto se hará sin perjuicio
                    de las acciones legales que puedan derivarse en términos de
                    responsabilidades civiles o penales.
                  </li>
                </ol>
                <p class="text-justify">
                  El Usuario reconoce que cualquier uso no autorizado de las
                  obras podrá generar responsabilidad administrativa, civil y/o
                  penal, conforme a la normativa de propiedad intelectual,
                  quedando Editora Perú facultada para iniciar las acciones
                  correspondientes ante INDECOPI y el Poder Judicial.
                </p>
              </div>

              <div class="section">
                <h5 class="subsection-title">
                  XVI. MODIFICACIÓN DE LOS TÉRMINOS Y CONDICIONES
                </h5>
                <p class="text-justify">
                  Editora Perú se reserva expresamente el derecho de modificar,
                  actualizar o ampliar los presentes Términos y Condiciones en
                  cualquier momento.
                </p>
                <p class="text-justify">
                  Cualquier cambio, actualización o ampliación en los presentes
                  Términos y Condiciones será publicado de inmediato,
                  y es responsabilidad del Usuario revisar los Términos y
                  Condiciones vigentes al momento de navegar en el sitio.
                </p>
                <p class="text-justify">
                  Además, si lo consideramos necesario, notificaremos a los
                  Usuarios sobre las modificaciones, actualizaciones o
                  ampliaciones de los Términos y Condiciones a través de correo
                  electrónico.
                </p>
                <p class="text-justify">
                  Si el Usuario no está de acuerdo con las modificaciones
                  mencionadas, puede optar por no utilizar los servicios
                  ofrecidos por Editora Perú a través del Archivo Histórico.
                </p>
              </div>

              <div class="section">
                <h5 class="subsection-title">XVII. PROPIEDAD INTELECTUAL</h5>
                <p class="text-justify">
                  Las Fotografías y Portadas Históricas disponibles en el Archivo
                  Histórico son propiedad exclusiva de Editora Perú y están
                  protegidas por el Decreto Legislativo N° 822 - Ley de Derechos
                  de Autor. Por lo tanto, está estrictamente prohibida, ya sea
                  en su totalidad o parcialmente, la reproducción, comunicación
                  al público, distribución, traducción, adaptación, arreglo,
                  transformación o cualquier otra forma de uso de estas obras y
                  productos sin la previa autorización de Editora Perú.
                </p>
                <p class="text-justify">
                  La adquisición de fotografías, portadas históricas o diarios
                  antiguos a través del Archivo Histórico no constituye en ningún
                  caso una cesión o transferencia de derechos patrimoniales de
                  autor, sino exclusivamente el otorgamiento de una licencia de
                  uso limitada, no exclusiva, revocable y sujeta a las
                  condiciones aquí establecidas, manteniendo Editora Perú la
                  titularidad íntegra de dichos derechos conforme al Decreto
                  Legislativo N.° 822.
                </p>
              </div>

              <div class="section">
                <h5 class="subsection-title">
                  XVIII. LIMITACIÓN DE RESPONSABILIDAD E INDEMNIDAD
                </h5>
                <p class="text-justify">
                  Editora Perú no garantiza que el Sitio Web funcione de manera
                  ininterrumpida, libre de errores o completamente seguro. En
                  tal sentido, no asumiremos responsabilidad alguna por los daños o
                  perjuicios que puedan generarse como consecuencia de
                  interrupciones del servicio, errores de funcionamiento,
                  omisiones, virus informáticos, fallas técnicas o desconexiones
                  que afecten el sistema electrónico.
                </p>
                <p class="text-justify">
                  Asimismo, Editora Perú no será responsable por retrasos,
                  bloqueos o deficiencias en el uso del sistema electrónico que
                  sean atribuibles a sobrecargas o fallos en la red de Internet
                  u otros sistemas externos. Tampoco será responsable por daños
                  derivados de accesos no autorizados o intrusiones ilegítimas
                  realizadas por terceros, cuando dichos actos se encuentren
                  fuera del control razonable de Editora Perú.
                </p>
              </div>

              <div class="section">
                <h5 class="subsection-title">XIX. COMUNICACIONES</h5>
                <p class="text-justify">
                  El Usuario acepta expresamente que la dirección de correo
                  electrónico consignada en el formulario de registro del Archivo
                  Histórico constituirá el canal oficial de comunicación entre
                  Editora Perú y el Usuario. En tal sentido, será
                  responsabilidad exclusiva del Usuario mantener dicha dirección
                  activa y operativa para efectos de recibir notificaciones,
                  avisos y demás comunicaciones relacionadas con los servicios
                  ofrecidos.
                </p>
                <p class="text-justify">
                  Asimismo, Editora Perú solo emitirá comunicaciones oficiales a
                  través de sus páginas web, cuentas verificadas en redes
                  sociales u otros medios institucionales. En caso se detecte
                  que un Usuario está enviando mensajes, publicaciones o
                  comunicaciones en nombre del Archivo Histórico sin autorización,
                  Editora Perú adoptará las medidas correctas y legales
                  correspondientes a fin de proteger a los demás Usuarios frente
                  a posibles confusiones, suplantaciones o riesgos derivados de
                  tales actos.
                </p>
              </div>

              <div class="section">
                <h5 class="subsection-title">
                  XX. FUERZA MAYOR O CASO FORTUITO
                </h5>
                <p class="text-justify">
                  Editora Perú no será responsable por la interrupción,
                  suspensión o mal funcionamiento del servicio ofrecido a través
                  del Archivo Histórico cuando ello se deba a causas de fuerza mayor
                  o caso fortuito, entendidos como aquellos eventos
                  imprevisibles, inevitables o ajenos al control razonable de la
                  empresa. Esto incluye, entre otros, desastres naturales,
                  conflictos sociales, fallos en sistemas externos, actos de
                  autoridades gubernamentales, cortes en el suministro eléctrico
                  o en las redes de telecomunicaciones, así como cualquier otra
                  circunstancia que impida el normal funcionamiento del Sitio
                  Web.
                </p>
              </div>

              <div class="section">
                <h5 class="subsection-title">XXI. LIBRO DE RECLAMACIONES</h5>
                <p class="text-justify">
                  Conforme a lo dispuesto en la Ley Nº 29571, Código de
                  Protección y Defensa del Consumidor, Editora Perú pone a
                  disposición de los Usuarios un Libro de Reclamaciones virtual,
                  a fin de que puedan presentar quejas o reclamos relacionados
                  con los servicios ofrecidos a través del Sitio Web.
                </p>
                <p class="text-justify">
                  El acceso al Libro de Reclamaciones virtual está disponible en
                  el siguiente enlace:
                  <a
                    href="https://www.editoraperu.com.pe/EditoraP/LibroReclamaciones.html"
                    target="_blank"
                  >
                    Libro de Reclamaciones
                  </a>
                </p>
              </div>

              <div class="section">
                <h5 class="subsection-title">
                  XXII. AUTORIDADES Y REQUERIMIENTOS LEGALES
                </h5>
                <p class="text-justify">
                  Editora Perú colabora con las autoridades competentes y
                  terceros con el fin de garantizar el cumplimiento de diversas
                  leyes en áreas como la protección de los derechos de propiedad
                  intelectual, la prevención del fraude, la lucha contra la
                  corrupción, la protección al consumidor, entre otras. En este
                  contexto, Editora Perú puede revelar la información personal
                  de los Usuarios del Archivo Histórico cuando así lo requieran las
                  autoridades administrativas, judiciales o gubernamentales
                  competentes. Esta revelación se realizará a discreción de
                  Editora Perú y en la medida en que se considere necesario para
                  investigaciones realizadas a cabo por estas autoridades, ya sean
                  de carácter penal, civil o administrativo.
                </p>
              </div>

              <div class="section">
                <h5 class="subsection-title">
                  XXIII. INEXISTENCIA DE SOCIEDAD O RELACIÓN LABORAL
                </h5>
                <p class="text-justify">
                  La participación de un Usuario en el Archivo Histórico no establece
                  ni implica la formación de un contrato de sociedad ni genera
                  una relación laboral entre el Usuario y Editora Perú.
                </p>
              </div>

              <div class="section">
                <h5 class="subsection-title">
                  XXIV. CESIÓN DE POSICIÓN CONTRACTUAL
                </h5>
                <p class="text-justify">
                  Los Usuarios otorgan su consentimiento expreso para que
                  Editora Perú pueda ceder total o parcialmente su posición
                  contractual derivada de los presentes Términos y Condiciones,
                  así como transferir la administración y tratamiento de la
                  información personal, a cualquier persona natural o jurídica
                  que:
                </p>
                <ol type="i">
                  <li>
                    Se obliga a cumplir con los presentes Términos y
                    Condiciones;
                  </li>
                  <li>
                    Asuma formalmente la administración del banco de datos
                    personales correspondiente.
                  </li>
                </ol>
                <p class="text-justify">
                  A partir de la fecha efectiva de dicha cesión o transferencia,
                  Editora Perú quedará eximida de toda responsabilidad por los
                  actos que puedan derivarse del uso de los datos personales,
                  siempre que dichos actos sean posteriores a la transferencia.
                  El nuevo responsable asumirá, en su totalidad, las
                  obligaciones contenidas en estos Términos y Condiciones y en
                  la Política de Privacidad respecto al tratamiento, custodia y
                  conservación de los datos personales de los Usuarios del Archivo
                  Histórico.
                </p>
              </div>

              <div class="section">
                <h5 class="subsection-title">XXV. GARANTÍAS</h5>
                <p class="text-justify">
                  Editora Perú garantiza que las obras y productos disponibles
                  en el Archivo Histórico son de su legítima titularidad y se
                  encuentran libres de reclamaciones de terceros. No obstante,
                  el Usuario reconoce y acepta que el uso de las obras y
                  productos se realiza bajo su responsabilidad exclusiva,
                  conforme a la licencia adquirida. Editora Perú no será
                  responsable por un uso indebido, inadecuado o no autorizado
                  por parte del Usuario.
                </p>
              </div>

              <div class="section">
                <h5 class="subsection-title">XXVI. INTEGRIDAD DEL CONTRATO</h5>
                <p class="text-justify">
                  Los presentes Términos y Condiciones, junto con la Política de
                  Privacidad y las condiciones particulares de la licencia
                  adquirida, constituyen el acuerdo íntegro entre el Usuario y
                  Editora Perú.
                </p>
              </div>

              <div class="section">
                <h5 class="subsection-title">XXVII. PRELACIÓN DE DOCUMENTOS</h5>
                <p class="text-justify">
                  El Usuario reconoce que la adquisición de la licencia no
                  incluye la autorización para el uso de la imagen, honor,
                  intimidad o cualquier otro derecho de personas que pudieran
                  aparecer en las fotografías o portadas históricas, siendo de su
                  exclusiva responsabilidad obtener las autorizaciones adicionales
                  que resulten necesarias para el uso que pretenda realizar.
                </p>
              </div>

              <div class="section">
                <h5 class="subsection-title">
                  XXVIII. LEY APLICABLE, JURISDICCIÓN Y MECANISMOS DE RESOLUCIÓN
                  ALTERNATIVA DE CONFLICTOS
                </h5>
                <p class="text-justify">
                  Los presentes Términos y Condiciones se rigen por las leyes de
                  la República del Perú. Cualquier controversia relacionada con
                  su interpretación, validez, ejecución o aplicación, incluyendo
                  lo dispuesto en la Política de Privacidad, será resuelta por
                  los jueces y tribunales del distrito judicial de Lima,
                  renunciando expresamente las partes a cualquier otro fuero que
                  pudiera corresponderles por razón de su domicilio presente o
                  futuro.
                </p>
                <p class="text-justify">
                  Sin perjuicio de ello, las partes podrán optar, de manera
                  previa a la vía judicial, por mecanismos de resolución
                  alternativa de conflictos, tales como la conciliación,
                  mediación u otros medios reconocidos por la normativa vigente.
                  Para tal efecto, podrán recurrir a los servicios brindados por
                  el INDECOPI o por centros autorizados en el territorio
                  nacional.
                </p>
              </div>
      </div>
    </div>

    <div class="col-sm-2"></div>
  </div>
</div>
